import React, { useCallback, useEffect } from 'react'

import { usePostLicenseV2ApplyMutation, usePutNoFieldsV2ApplyMutation } from '@core/app/api/applyJobV2Api'
import { currentStep } from '@core/app/slices/auth'
import ApplyV2Switch from '@core/components/ApplyDialogV2/ApplyV2Switch'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'

interface Props {
    checked: boolean
    label?: string
    onChange: (checked: boolean) => void
    onFocus?: React.FocusEventHandler<HTMLInputElement>
    onBlur?: React.FocusEventHandler<HTMLInputElement>
    isDisabled?: boolean
    className?: string
    id?: string | number
    name?: string
    isLoading?: boolean
    errorMessage?: string | null
    children?: React.ReactNode
    isShowErrorMessage?: boolean
}

function ApplyV2NoFieldsSwitch(props: Props) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        // isFinalStep,
        // setIsFinalStep,
        isPostApplied,
        onCloseApply,
        setNavItemsStates,
        navItems,
        storageData,
    } = useApplyV2Context()
    const [request, { isLoading }] = usePutNoFieldsV2ApplyMutation()
    const [postLicense] = usePostLicenseV2ApplyMutation()
    // const [value, setValue] = React.useState<boolean>(false)

    const driverLicence = postProfileData?.data?.driverLicence ?? []

    useEffect(() => {
        const currentStep = storageData?.currentStep ?? postProfileData?.data?.step
        const noFields = Object.values(postProfileData?.data?.noFields ?? [])

        if (currentStep === 'driverLicence' && driverLicence) {
            if (driverLicence.includes(66)) {
                noFields.push('driverLicence')
            }
        }

        if (Array.isArray(noFields) && currentStep != null && typeof currentStep !== 'object') {
            props.onChange(noFields.includes(currentStep))
        } else {
            props.onChange(false)
        }
    }, [
        postProfileData?.data?.noFields,
        postProfileData?.data?.step,
        postProfileData?.data?.driverLicence,
        storageData?.currentStep,
    ])

    const onHandleChange = useCallback(
        (v: React.ChangeEvent<HTMLInputElement>) => {
            const currentStep = storageData?.currentStep ?? postProfileData?.data?.step

            if (currentStep === 'driverLicence' && postProfileData?.data?.uid) {
                postLicense({
                    uid: postProfileData.data.uid,
                    body: {
                        // ids: driverLicence,
                        ids: v.target.checked ? [66] : [],
                    },
                })
            } else {
                request({
                    uid: postProfileData?.data?.uid,
                    field: currentStep,
                    value: v.target.checked,
                })
            }
            props.onChange(v.target.checked)
        },
        [request, postProfileData?.data?.uid, storageData?.currentStep, postProfileData?.data?.step, props.onChange]
    )

    return (
        <ApplyV2Switch
            className={props.className}
            checked={props.checked}
            label={props.label}
            onChange={onHandleChange}
            isLoading={isLoading}
        />
    )
}

export default ApplyV2NoFieldsSwitch
